import { Link } from "react-router-dom";
import { ArrowRight, Phone } from "lucide-react";
import { PHONE_DISPLAY, PHONE_TEL } from "@/lib/site";
import { Reveal } from "./Reveal";

export default function SectionCTA({
  title = "Tell us what you want to build",
  copy = "Whether you already have plans or are still figuring out where to begin, our team can help determine the next steps.",
}) {
  return (
    <section className="border-t border-line bg-coal" data-testid="section-cta">
      <div className="mx-auto flex max-w-7xl flex-col items-start justify-between gap-8 px-4 py-16 sm:px-8 sm:py-20 lg:flex-row lg:items-center lg:px-16">
        <Reveal>
          <h2 className="max-w-xl font-display text-2xl font-black uppercase leading-tight tracking-tight sm:text-3xl">{title}</h2>
          <p className="mt-4 max-w-lg text-sm leading-relaxed text-fog">{copy}</p>
        </Reveal>
        <Reveal delay={0.12} className="flex flex-col gap-3 sm:flex-row">
          <Link to="/contact" data-testid="section-cta-consult-button" className="btn-primary">
            Request a Project Consultation <ArrowRight className="h-4 w-4" />
          </Link>
          <a href={PHONE_TEL} data-testid="section-cta-call-button" className="btn-outline">
            <Phone className="h-4 w-4" /> {PHONE_DISPLAY}
          </a>
        </Reveal>
      </div>
    </section>
  );
}
